import React, {Component} from 'react';
import { connect } from "react-redux";
import {Row, Col, Button, Fa} from "mdbreact";
import {API_URL, IMAGE_URL} from "../../config/Config";
import axios from "axios/index";
import SweetAlert from 'sweetalert2-react';
import SaveLoader from "../loader/SaveLoader";
import axiosRetry from 'axios-retry';
import {Link} from "react-router-dom";

axiosRetry(axios, { retries: 3 });

class ProductComplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price:0,
            quantity:1,

            loading:true,
            isSave:false,
            type:'success',
            title:'خرید شما با موفقیت ثبت شد'
        };
    }

    async buyFreeCart(id){
        this.setState({loading: false});
        try {
            let response = await axios.get(`${API_URL}cart-buy/${id}?api_token=${this.props.user.apiToken}`);
            // let order = await response.data.data;
            let status = await response.data.status;
            await this.setState({loading:false});
            if (status === "success"){
                this.setState({
                    isSave:true,
                    type:'success',
                    title:'خرید شما با موفقیت ثبت شد'
                });
            }else{
                this.setState({isSave:true});
                this.setState({
                    isSave:true,
                    type:'error',
                    title: "خطایی در هنگام ثبت درخواست شما رخ داد"
                });
            }


        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                await this.setState({loading: true});
                this.setState({
                    isSave:true,
                    type:'error',
                    title: statusText
                });
            }
        }
        this.setState({loading: true});
    }

    render() {
        const { productObj } = this.props;

        return (
            <div className="product-list-item mb-5">

                <Row>
                    <Col sm="12" md="4" >
                        <img src={IMAGE_URL+productObj.image_url} alt={productObj.title} className="w-100"/>

                        <div className="clearfix m-4">
                            {/*<select className="browser-default  p-1 border-dark w-100 text-center" onChange={e => this.setState({ quantity: e.target.value })} value={this.state.quantity}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>*/}
                        </div>
                    </Col>
                    <Col sm="12" md="8" >
                        <Row className="mb-3">
                            <div className="d-flex justify-content-end  w-100 pl-0" >
                                {(productObj.has_offer === '1') ? <div><div className="text-white primary-color-dark product-item-lables">پیشنهاد ویژه</div></div>: ""}
                                {productObj.discount_amount !==0 ? <div><div className="text-white danger-color-dark product-item-lables">{productObj.discount_amount} ریال تخفیف </div></div>: ""}
                            </div>
                        </Row>
                        <Row className="mb-5">
                            <Col md="8" sm='12' className="pr-0">
                                <h2 className="mt-5 deep-orange-text">{productObj.title}</h2>
                            </Col>
                            <Col md="4" sm='12' className="pl-0">
                                <div className="text-left" >
                                    <p><span className="oldPrice ng-binding">{productObj.price_org} ریال<span className="cross-price" style={{backgroundColor: "#0092cf"}}/></span></p>
                                    <p><span className="newPrice"><span className="price ng-binding">{productObj.price}</span> <span className="currancy"> ریال</span> </span></p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <p className="text-justify">{productObj.description}</p>
                        </Row>

                        <Row className="mt-5">
                            <Col md="6" sm="12"/>
                            <Col md="6" sm="12" className="text-center">
                                {/*<Button outline block color="info" className="product-add-to-cart"><Fa icon="shopping-cart" className="mr-1"/> خرید {productObj.price} ریال</Button>*/}
                                {(this.props.user.apiToken === null)?
                                    <Link to={`login`} className="btn btn-outline-info btn-block Ripple-parent product-add-to-cart"><Fa icon="shopping-cart" className="mr-1"/> خرید {productObj.price} ریال</Link>
                                    :
                                    <div>
                                        {(productObj.price === "0") ?
                                            <Button onClick={this.buyFreeCart.bind(this,productObj.id)} outline block  color="info" className="product-add-to-cart"> خرید {productObj.price} ریال</Button>
                                            :
                                            <a className="btn btn-outline-info btn-block Ripple-parent product-add-to-cart"
                                               href={`${API_URL}cart/buy/${productObj.id}?api_token=${this.props.user.apiToken}`}
                                               target='_blank'>خرید و فعال سازی ({productObj.price} تومان)</a>
                                        }
                                    </div>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {!this.state.loading ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}
                <SweetAlert
                    show={this.state.isSave}
                    title={this.state.title}
                    type={this.state.type}
                    showConfirmButton={true}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, null)(ProductComplate);


// WEBPACK FOOTER //
// ./src/components/product/ProductComplate.js